import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const opsgenieScheduleRoute: InvariantJiraRoute = {
	name: 'opsgenie-schedule',
	path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule',
};
